'use client';

import type { MouseEvent } from 'react';
import { Button } from '../../../components/button';
import { Spinner } from '../../../components/spinner';

const absorbSpinnerClick = (event: MouseEvent<HTMLButtonElement>) => {
  event.preventDefault();
};

export const DocumentationFilesUploadSpinnerSlot = () => (
  <Button
    type="button"
    variant="ghost"
    size="sm"
    fontWeight="normal"
    aria-busy
    tabIndex={-1}
    pointerEvents="none"
    cursor="default"
    onClick={absorbSpinnerClick}
  >
    <Spinner size="sm" />
  </Button>
);
